import {
  ACTION_GET_TRANSACTIONS,
  ACTION_GET_TRANSACTIONS_SUCCESS,
  ACTION_GET_TRANSACTIONS_FAILURE,
  ACTION_GET_TRANSACTIONS_BY_PARAMS,
  ACTION_GET_TRANSACTIONS_BY_PARAMS_SUCCESS,
  ACTION_GET_TRANSACTIONS_BY_PARAMS_FAILURE,
  ACTION_SELECT_TRANSACTION_TABLE_ROW,
  ACTION_DISCARD_TRANSACTIONS_SUCCESS,
  ACTION_DISCARD_TRANSACTIONS_FAILURE,
  ACTION_RESTORE_TRANSACTIONS,
  ACTION_DISCARD_TRANSACTIONS,
  ACTION_RESTORE_TRANSACTIONS_FAILURE,
  ACTION_RESTORE_TRANSACTIONS_SUCCESS,
} from '../configs/ActionTypes';

import * as _ from 'lodash-es';

const initialState: {
  transactions: any[];
  isLoading: boolean;
  success: boolean | null;
} = {
  transactions: [],
  isLoading: false,
  success: null,
};

export default function (state = initialState, action: any) {
  switch (action.type) {
    case ACTION_GET_TRANSACTIONS: {
      return {
      ...state,
      isLoading: true,
      success: null,
      };
    }

    case ACTION_GET_TRANSACTIONS_SUCCESS: {
      const transactions = action.payload?.payload || [];
      return {
      ...state,
      transactions: [...transactions],
      isLoading: false,
      success: null,
      };
    }

    case ACTION_GET_TRANSACTIONS_FAILURE: {
      return {
      ...state,
      transactions: [],
      isLoading: false,
      success: false,
      };
    }

    case ACTION_DISCARD_TRANSACTIONS: {
      return {
      ...state,
      isLoading: true,
      success: null,
      };
    }

    case ACTION_RESTORE_TRANSACTIONS: {
      return {
      ...state,
      isLoading: true,
      success: null,
      };
    }

    case ACTION_DISCARD_TRANSACTIONS_FAILURE: {
      return {
      ...state,
      success: false,
      isLoading: false,
      };
    }

    case ACTION_DISCARD_TRANSACTIONS_SUCCESS: {
      return {
      ...state,
      success: true,
      isLoading: false,
      };
    }

    case ACTION_RESTORE_TRANSACTIONS_FAILURE: {
      return {
      ...state,
      success: false,
      isLoading: false,
      };
    }

    case ACTION_RESTORE_TRANSACTIONS_SUCCESS: {
      return {
      ...state,
      success: true,
      isLoading: false,
      };
    }

    case ACTION_GET_TRANSACTIONS_BY_PARAMS: {
      return {
        ...state,
        isLoading: true,
        success: null,
      };
    }

    case ACTION_GET_TRANSACTIONS_BY_PARAMS_SUCCESS: {
      const transactions = action.payload?.payload || [];
      return {
        ...state,
        transactions,
        isLoading: false,
        success: true,
      };
    }

    case ACTION_GET_TRANSACTIONS_BY_PARAMS_FAILURE: {
      return {
        ...state,
        isLoading: false,
        success: false,
      };
    }

    case ACTION_SELECT_TRANSACTION_TABLE_ROW: {
      const transactions = [...state.transactions];
      const transactionIndex = state.transactions.findIndex(
        (t) => t.id === action.payload.id,
      );
      const transaction = state.transactions[transactionIndex];
      transactions[transactionIndex] = {
        ...transaction,
        isSelected: !transaction.isSelected,
      };
      return {
        ...state,
        transactions,
      };
    }

    default: {
      return state;
    }
  }
}
